import { Progress as ProgressPrimitive } from "@base-ui/react/progress";

import { cn } from "@/lib/utils";

function Progress({
  className,
  value,
  ...props
}: ProgressPrimitive.Root.Props) {
  return (
    <ProgressPrimitive.Root
      className={cn("relative w-full", className)}
      data-slot="progress"
      value={value}
      {...props}
    >
      <ProgressPrimitive.Track
        className="block h-1.5 w-full overflow-hidden rounded-full bg-muted"
        data-slot="progress-track"
      >
        <ProgressPrimitive.Indicator
          className="block h-full rounded-full bg-primary transition-all duration-300 ease-out"
          data-slot="progress-indicator"
        />
      </ProgressPrimitive.Track>
    </ProgressPrimitive.Root>
  );
}

export { Progress };
